import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {

  updateMessage(event) {
    Rails.fire(this.element, 'submit');
  }
}
